<template>
  <ion-item class="submission-item" @click="openModal">
    <ion-label>
      <div class="title">{{ spaceBetweenWords(item.form_type)}}</div>
      <div class="date-wrapper">
        <Calendar></Calendar>
        <div class="date">
          <strong>Date:</strong>
          <p>{{ formatDate(item.created_at) }}</p>
        </div>
      </div>
      <div class="status-wrapper">
        <ChargingCircle></ChargingCircle>
        <div class="status">
          <strong>Status:</strong>
          <div :class="item.status" class="status-item">
            {{ item.status }}
          </div>
        </div>
      </div>
    </ion-label>
    <Arrow class="arrow"></Arrow>
  </ion-item>
</template>

<script>
  import {IonItem, IonLabel, modalController} from '@ionic/vue'
  import ChargingCircle from "@/components/icons/ChargingCircle.vue"
  import Calendar from "@/components/icons/Calendar.vue"
  import Arrow from "@/components/icons/Arrow.vue"
  import "@/theme/components/submission-item.scss"
  import Modal from '@/components/Modal.vue'
  import PlasticWatch from "@/views/pages/submissions/PlasticWatch.vue";
  import AlgaeWashup from "@/views/pages/submissions/AlgaeWashup.vue";
  import AtmosphericCondition from "@/views/pages/submissions/AtmosphericCondition.vue";
  import HumanActivity from "@/views/pages/submissions/HumanActivity.vue";
  import StormDamage from "@/views/pages/submissions/StormDamage.vue";
  import WildlifeReport from "@/views/pages/submissions/WildlifeReport.vue";

  export default {
    name: "SubmissionItem",
    components: {IonItem, IonLabel, ChargingCircle, Calendar, Arrow},

    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },

    methods: {
      formatDate(date) {
        return new Date(date).toLocaleDateString('en-US', {hour: 'numeric', hour12: true, minute: 'numeric'}).replace(/\//g, '-')
      },
      spaceBetweenWords(string) {
        return string.replace(/([A-Z])/g, ' $1').trim()
      },
      async openModal() {
        const isDraft = this.item.status === 'Draft';
        const modal = await modalController
          .create({
            component: isDraft ? this.getComponentFromType(this.item.form_type) : Modal,
            cssClass: 'my-custom-class',
            componentProps: isDraft ? {
              selectedDraft: this.item
            } : {
              title: this.spaceBetweenWords(this.item.form_type),
              id: this.item.id,
            },
          });

        modal.onDidDismiss().then(() => this.$emit('refreshList'));

        return await modal.present();
      },
      getComponentFromType(type) {
        switch (type) {
          case 'PlasticWatch':
            return PlasticWatch;
          case 'AlgaeWashup':
            return AlgaeWashup;
          case 'AtmosphericCondition':
            return AtmosphericCondition;
          case 'HumanActivity':
            return HumanActivity;
          case 'StormDamage':
            return StormDamage;
          case 'WildlifeReport':
            return WildlifeReport;
          default:
            return null;
        }
      }
    }
  }
</script>

<style scoped>

</style>
